'use client';

import type {FC} from 'react';
import {useLiveQuery} from 'next-sanity/preview';

import {FullPageSpinner} from 'components/full-page-spinner';
import {Page as PageRender} from 'components/page';

import type {PageBySlugQueryResult} from '../../../components/page/query';
import {PAGE_BY_SLUG_QUERY} from '../../../components/page/query';

interface Props {
	pageSlug: string;
	isDraft: boolean;
}

export const PageDraft: FC<Props> = ({pageSlug, isDraft}) => {
	const [page, loading] = useLiveQuery<PageBySlugQueryResult>(null, PAGE_BY_SLUG_QUERY, {
		pageSlug,
	});

	if (loading) {
		return <FullPageSpinner />;
	}

	return <PageRender page={page} isDraft={isDraft} />;
};
